

$(function () {
  	initPrintAnimation();
  });
  function isMobileWidth() {
    return $('#mobile-indicator').is(':visible');
}

function isPhabletWidth() {
    return $('#phablet-indicator').is(':visible');
}

function isTabletWidth() {
    return $('#tablet-indicator').is(':visible');
}
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

/*
  Page section - cameras/printers/film
*/

var width = $(window).width();
function cpf_text() {
	$('.cpf .big-text').textfill({
		maxFontPixels: 0,
		success: function() {
			$('.cpf .big-text span').css('opacity','1');
		},
	});
}
 
$(window).on('load', function() {
	cpf_text();
});

/*
  Print on scroll animation
*/

function initPrintAnimation() {
	var pat1 = $('.pat-1'), 
		pac1 = $('.pac-1'),
		pat2 = $('.pat-2'),
		pac2 = $('.pac-2'),
		pat3 = $('.pat-3'),
		pat4 = $('.pat-4');
		pat5 = $('.pat-5');
		
	var circle = document.querySelector('.progress-circle-path');
	var radius = circle.r.baseVal.value;
	var circumference = radius * 2 * Math.PI;
	circle.style.strokeDasharray = `${circumference} ${circumference}`;
	circle.style.strokeDashoffset = `${circumference}`;
	
	function update_progress(progress) {
		var offset = circumference - progress * circumference;
		var percent = (progress * 90).toFixed(0);
		circle.style.strokeDashoffset = offset;
		$('.progress-time').text(percent);
	}
	
	gsap.registerPlugin(ScrollTrigger);
	
	gsap.defaults({
		ease: 'none',
		duration: 5,
	});
	
	gsap.set(pat1, { autoAlpha: 1 });
	gsap.set('.slide-camera', { autoAlpha: 1 });
	gsap.set('.slide-camera-01', { autoAlpha: 1 });
	gsap.set('.slide-film', { x: '-8.5%', scale: 0.7, rotation: 180 });
	gsap.set('.film-shine', { rotation: 10 });
	
	gsap.timeline({
		scrollTrigger: {
			trigger: '.print-anim-container',
			pin: false,
			start: 'top top',
			end: 'bottom bottom',
			scrub: true,
		}
	})
	
	// reveal "take a snap"
	.to(pac1, { autoAlpha: 1 })
	
	// quickly reveal and hide camera flash
	.to('.camera-flash', { opacity: 1, duration: 0.3 })
	.to('.camera-flash', { opacity: 0, duration: 3 }, '>0.5')
	
	// hide "take" and "take a snap" together
	.to(pat1, { autoAlpha: 0 }, '>3')
	.to(pac1, { autoAlpha: 0 }, '<')
	
	// begin rotation of camera by hiding and revealing each slide in turn
	.to('.slide-camera-01', { duration: 0, autoAlpha: 0 }, '<')
	.to('.slide-camera-02', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-02', { duration: 0, autoAlpha: 0 }, '>.5')
	.to('.slide-camera-03', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-03', { duration: 0, autoAlpha: 0 }, '>.4')
	.to('.slide-camera-04', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-04', { duration: 0, autoAlpha: 0 }, '>.4')
	.to('.slide-camera-05', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-05', { duration: 0, autoAlpha: 0 }, '>.3')
	.to('.slide-camera-06', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-06', { duration: 0, autoAlpha: 0 }, '>.3')
	.to('.slide-camera-07', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-07', { duration: 0, autoAlpha: 0 }, '>.3')
	.to('.slide-camera-08', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-08', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-09', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-09', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-10', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-10', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-11', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-11', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-12', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-12', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-13', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-13', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-14', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-14', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-15', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-15', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-16', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-16', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-17', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-17', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-18', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-18', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-19', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-19', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-20', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-20', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-21', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-21', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-22', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-22', { duration: 0, autoAlpha: 0 }, '>.1')
	.to('.slide-camera-23', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-23', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-24', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-24', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-25', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-25', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-26', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-26', { duration: 0, autoAlpha: 0 }, '>.2')
	.to('.slide-camera-27', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-27', { duration: 0, autoAlpha: 0 }, '>.3')
	.to('.slide-camera-28', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-28', { duration: 0, autoAlpha: 0 }, '>.3')
	.to('.slide-camera-29', { duration: 0, autoAlpha: 1 }, '<')
	
	// reveal "and..."
	.to(pat2, { autoAlpha: 1 }, '>.3')
	
	.to('.slide-camera-29', { duration: 0, autoAlpha: 0 }, '<')
	.to('.slide-camera-30', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-30', { duration: 0, autoAlpha: 0 }, '>.4')
	.to('.slide-camera-31', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-31', { duration: 0, autoAlpha: 0 }, '>.4')
	.to('.slide-camera-32', { duration: 0, autoAlpha: 1 }, '<')
	
	.to('.slide-camera-32', { duration: 0, autoAlpha: 0 }, '>.5')
	.to('.slide-camera-33', { duration: 0, autoAlpha: 1 }, '<')
	
	// make film slides visible, ready for printing
	.to('.slide-film', { duration: 0, autoAlpha: 1 })
	.to('.slide-film-01', { duration: 0, autoAlpha: 1 })
	.to('.slide-film-04', { duration: 0, autoAlpha: 1 })
	
	// slide the film up and the camera down
	.to('.slide-film', { y: '-18%' })
	.to('.slide-camera', { y: '54%' }, '<')
	
	// continue sliding the camera down and hidden while bringing film slide into center and full size, reveal "watch your image come to life"
	.to('.slide-film', { duration: 10, y: '0%', x: '0%', scale: 1, rotation: 0 })
	.to('.slide-camera', { y: '108%', autoAlpha: 0 }, '<')
	.to(pac2, { autoAlpha: 1 }, '<5')
	
	// reveal progress
	.to('.progress-wrapper', { autoAlpha: 1 })
	
	// start progress count
	.to('.progress-wrapper', {
		duration: 10,
		onUpdate: function () {
			update_progress(this.progress());
		}
	})
	
	// develop film, starting out slower and increasing speed
	.to('.slide-film-02', { duration: 4, autoAlpha: 0.1 }, '<')
	.to('.slide-film-02', { duration: 3, autoAlpha: 0.3 }, '<4')
	.to('.slide-film-02', { duration: 2, autoAlpha: 0.6 }, '<3')
	.to('.slide-film-02', { duration: 1, autoAlpha: 1 }, '<2')
	
	// reveal shine and move across image
	.to('.slide-film-03, .film-shine', { duration: 0.5, autoAlpha: 1 }, '>3')
	.to('.film-shine', { duration: 10, x: '300%'}, '<')
	.to('.slide-film-03, .film-shine', { duration: 0.5, autoAlpha: 0 })
	
	// hide "and..", "watch your image come to life" and progress
	.to(pat2, { autoAlpha: 0 }, '>5')
	.to(pac2, { autoAlpha: 0 }, '<')
	.to('.progress-wrapper', { autoAlpha: 0 }, '<')
	
	// reveal "give some love"
	.to(pat3, { autoAlpha: 1 })
	
	// hide "give some love" and mini film
	.to(pat3, { autoAlpha: 0 }, '>5')
	.to('.slide-film', { autoAlpha: 0 }, '<')
	
	// reveal "give your take" and square film
	.to(pat4, { autoAlpha: 1 })
	.to('.slide-film-square', { autoAlpha: 1 }, '<')
	
	// hude "give your take" and square film
	.to(pat4, { autoAlpha: 0 }, '>5')
	.to('.slide-film-square', { autoAlpha: 0 }, '<')
	
	// reveal "give good vibes" and wide film
	.to(pat5, { autoAlpha: 1 })
	.to('.slide-film-wide', { autoAlpha: 1 }, '<')
	
	// add a short pause before moving on
	.set({}, {}, "+=10")
}

function printAnimationSizes() {
	var maxHeight = -1;
	$('.print-anim-text-wrap').each(function() {
		maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
	});
	$('.print-anim-text').height(maxHeight);
	
	// Set .print-anim-graphics width to match its height. Start by
	// resetting .print-anim-graphics to 50%, defined in css
	$('.print-anim-graphics').height('');
	
	// Check if making the width equal to the height makes
	// .print-anim-graphics wider than the page (using .print-anim-text
	// for reference). If so, make .print-anim-text into a square equal
	// to the width of the page
	var graphicsHeight = $('.print-anim-graphics').height();
	var textWidth = $('.print-anim-text').width();
	if( textWidth > graphicsHeight ){
		$('.print-anim-graphics').width(graphicsHeight);
	} else {
		$('.print-anim-graphics').width(textWidth).height(textWidth);
	}
	
	if( isPhabletWidth() ) {
		$('.progress-wrapper').css({'margin-left': '', 'margin-top': ''});
	} else {
		var graphicsWidth = $('.print-anim-graphics').width();
		$('.progress-wrapper').css({'margin-left': (graphicsWidth*0.5)+'px', 'margin-top': (maxHeight*0.5)+'px'});
	}
}

$(document).ready(function() {
	printAnimationSizes();
});

$(window).on('resize', function() {
	printAnimationSizes();
});

$(document).ready(function() {
	$('.print-anim-skip').on('click',function(e){
		e.preventDefault();
		var section = $(this).closest('.print-anim-container');
		var sHeight = $(section).height();
		$(window).scrollTop( $(section).offset().top + sHeight ) 
	});

	$('.print-anim-back').on('click',function(e){
		e.preventDefault();
		$(window).scrollTop( $('.header-wrapper').offset().top )
	});
});